export function formatPrice(price) {
  if (price == null || isNaN(price)) {
    return "";
  }
  const parts = price.toFixed(2).toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}